(function() {
    'use strict';
    angular
        .module('bozorakaAdminApp')
        .factory('ProviderCountry', ProviderCountry);

    ProviderCountry.$inject = ['$resource', 'DateUtils'];

    function ProviderCountry ($resource, DateUtils) {
        var resourceUrl =  'api/provider-countries/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.createdDate = DateUtils.convertDateTimeFromServer(data.createdDate);
                        data.lastModifiedDate = DateUtils.convertDateTimeFromServer(data.lastModifiedDate);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' },
            'getAsList': {
                method: 'GET',
                isArray: true,
                url: 'api/provider-country-list'
            }
        });
    }
})();
